<template>
  <div class="fSize">
    <van-list v-model="loading" :finished="finished" @load="getList" :error.sync="error"
              error-text="请求失败，点击重新加载">
      <van-cell class="newCell" is-link v-for="(item,index) in list" :key="index" @click="goToDetail(item.id)">
        <span>{{ item.userName }}</span>
        <span style="margin-left:0.25rem">{{ item.preDate }}</span>
      </van-cell>
    </van-list>
    <van-empty v-show="list.length<1" description="暂无预约信息..."/>
    <br/><br/>
    <van-cell class="buttonFixed" safe-area-inset-bottom>
      <van-button size="normal" round block type="info" @click="goToAppointment">立即预约</van-button>
    </van-cell>
  </div>
</template>
<script>
import {getAppointmentList, delAppiontment} from "@/api/common";
import {Cell, List, SwipeCell, Button, Empty, Toast, Dialog, NoticeBar, ActionSheet} from "vant";

export default {
  components: {
    [Cell.name]: Cell, [List.name]: List, [SwipeCell.name]: SwipeCell, [Button.name]: Button,
    [Empty.name]: Empty, [Toast.name]: Toast, [Dialog.name]: Dialog, [NoticeBar.name]: NoticeBar,
    [ActionSheet.name]: ActionSheet
  },
  data() {
    return {
      list: [],
      listQuery: {
        page: 1,
        limit: 10
      },
      loading: false,
      finished: false,
      error: false,
      errorText: "请求失败，点击重新加载",
    };
  },
  mounted() {
    var _this = this;
    window.history.pushState(null, null, "#");
    window.addEventListener(
        "popstate",
        _this.closePage,
        false
    );
  },
  methods: {
    closePage() {
      WeixinJSBridge.call("closeWindow");
    },
    //searchFun
    resetFun() {
      const that = this;
      that.finished = false;
      that.error = false;
      that.errorText = "请求失败，点击重新加载";
      that.list = [];
      that.listQuery = {
        page: 1,
        limit: 10
      };
    },
    //获取预约信息
    getList() {
      const that = this;
      that.loading = true;
      let data = JSON.parse(JSON.stringify(that.listQuery));
      data.openId = sessionStorage.getItem("openid");
      getAppointmentList(data).then(resp => {
        Toast.clear();
        that.loading = false;
        if (resp.code === 200) {
          that.listQuery.page = that.listQuery.page + 1;
          let newArray = resp.data ? resp.data : [];
          that.list.push.apply(that.list, newArray);
          if (that.list.length >= resp.count) {
            that.finished = true;
          }
        } else {
          that.error = true;
          that.errorText = resp.msg + "，请点击重试";
        }
      }).catch(err => {
        Toast.clear();
        console.log(err);
      });
    },
    //删除用户
    deleteData(e) {
      const that = this;
      Dialog.confirm({
        message: "确认取消预约信息吗？"
      }).then(() => {
        delAppiontment({id: e}).then(resp => {
          if (resp.code === 200) {
            Toast({
              type: "success",
              message: "预约取消成功",
              duration: 0,
              onOpened: function () {
                that.resetFun();
                that.getList();
              }
            });
          } else {
            Toast({
              type: "fail",
              message: resp.msg
            });
          }
        }).catch(err => {
          console.log(err);
        });
      }).catch(() => {
        console.log("取消了删除...");
      });
    },
    // 跳转到预约详情页面
    goToDetail(id) {
      const that = this;
      window.removeEventListener(
          "popstate",
          that.closePage
      );
      this.$router.push({
        path: "/appointmentDetail",
        query: {id: id}
      });
    },
    // 跳转到在线预约界面
    goToAppointment() {
      const that = this;
      //先判断是否绑定用户
      if (sessionStorage.getItem("userIsBang") !== "yes") {
        //如果用户信息为空则去设置用户
        Toast("未绑定用户，请先绑定体检用户！");
        return false;
      }
      window.removeEventListener(
          "popstate",
          that.closePage
      );
      that.$router.push({path: "/onlineBooking"});
    },
    //关闭添加框组件
    closeFun() {
      const that = this;
      that.show = false;
      //刷新列表数据
      that.resetFun();
      that.getList();
    }
  }
};
</script>
<style scoped>
.newHeight {
  padding-bottom: 0;
}

.newStyle {
  height: 100%;
}

.newSwipe {
  margin: 0.2rem 0;
}

.newCell {
  line-height: 0.6rem;
}
</style>
